import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import WinnerDropBadge from "../drops/winner/WinnerDropBadge";
interface SingleWaveDropPositionProps {
  readonly rank: number | null;
  readonly drop?: ExtendedDrop;
  readonly isFinalWinner?: boolean;
  readonly variant?: "default" | "simple";
}
const TrophyOnlyBadge: FC<{
  rank: number;
}> = t0 => {
  const $ = _c(7);
  const {
    rank
  } = t0;
  let accentColor;
  let bgColor;
  bb0: switch (rank) {
    case 1:
      {
        accentColor = "#fbbf24";
        bgColor = "rgba(251,191,36,0.1)";
        break bb0;
      }
    case 2:
      {
        accentColor = "#CAD5E3";
        bgColor = "rgba(202, 213, 227,0.1)";
        break bb0;
      }
    case 3:
      {
        accentColor = "#CD7F32";
        bgColor = "rgba(205,127,50,0.1)";
        break bb0;
      }
    default:
      {
        accentColor = "#848490";
        bgColor = "rgba(96,96,108,0.1)";
      }
  }
  const t1 = `1px solid ${accentColor}30`;
  let t2;
  if ($[0] !== accentColor || $[1] !== bgColor || $[2] !== t1) {
    t2 = {
      backgroundColor: bgColor,
      color: accentColor,
      border: t1
    };
    $[0] = accentColor;
    $[1] = bgColor;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-px-2 tw-py-1 tw-text-xs tw-flex tw-items-center"><FontAwesomeIcon icon={faTrophy} className="tw-size-2.5 tw-flex-shrink-0" /></span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="tw-flex tw-items-center tw-rounded-md tw-font-medium tw-whitespace-nowrap -tw-mt-0.5" style={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
const SimpleRankDisplay: FC<{
  rank: number;
}> = t0 => {
  const $ = _c(6);
  const {
    rank
  } = t0;
  let color;
  bb0: switch (rank) {
    case 1:
      {
        color = "tw-text-amber-400";
        break bb0;
      }
    case 2:
      {
        color = "tw-text-iron-300";
        break bb0;
      }
    case 3:
      {
        color = "tw-text-amber-600";
        break bb0;
      }
    default:
      {
        color = "tw-text-iron-500";
      }
  }
  const formatRank = _temp;
  const t1 = `tw-flex tw-items-center tw-gap-1.5 ${color}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FontAwesomeIcon icon={faTrophy} className="tw-w-3.5 tw-h-3.5" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = formatRank(rank);
  let t4;
  if ($[1] !== t3) {
    t4 = <span className="tw-text-sm tw-font-semibold">{t3}</span>;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t1 || $[4] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[3] = t1;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export const SingleWaveDropPosition: FC<SingleWaveDropPositionProps> = t0 => {
  const $ = _c(6);
  const {
    rank,
    drop,
    isFinalWinner: t1,
    variant: t2
  } = t0;
  const isFinalWinner = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "default" : t2;
  if (!rank) {
    return null;
  }
  if (variant === "simple") {
    let t3;
    if ($[0] !== rank) {
      t3 = <SimpleRankDisplay rank={rank} />;
      $[0] = rank;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  const isWinner = isFinalWinner || drop?.winning_context;
  if (isWinner) {
    let t3;
    if ($[2] !== rank) {
      t3 = <div className="tw-flex tw-flex-col tw-items-start tw-gap-2"><TrophyOnlyBadge rank={rank} /></div>;
      $[2] = rank;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== rank) {
    t3 = <div className="tw-flex tw-flex-col tw-items-start tw-gap-2"><WinnerDropBadge rank={rank} decisionTime={null} /></div>;
    $[4] = rank;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
function _temp(r) {
  switch (r) {
    case 1:
      {
        return "1st";
      }
    case 2:
      {
        return "2nd";
      }
    case 3:
      {
        return "3rd";
      }
    default:
      {
        return `#${r}`;
      }
  }
}